<template>
    <div class="side-bar">
        <transition name="fade">
            <div class="side-mask" v-show="isSideShow" @click="hideSide"></div>
        </transition>

        <transition name="slide-fade">
            <div class="side-content" v-show="isSideShow">
                <a class="side-close" @click="hideSide"></a>
                <div class="header-top">
                    <div class="user-box">
                        <div class="avatar-box">
                            <img ref="imgShow" :src="avatarUrl" :class="isHeight ? 'hovImg' : 'verImg'"/>
                        </div>
                        <div class="user-info" v-if="isLoginShow">
                            <h4>{{this.data.nickname}}</h4>
                            <p><i></i>{{moneyStr(this.data.coins)}}</p>
                        </div>
                    </div>
                    <a class="side-login" @click="toGo">{{this.isLoginShow ? txtLang[langName]['userCenter'] : txtLang[langName]['login']}}</a>
                </div>
                <ul class="side-menu">
                    <li class="sm-guess">
                        <router-link :to="{name: 'List'}">
                            <i></i><span>{{txtLang[langName]['mGuess']}}</span>
                        </router-link>
                    </li>
                    <li class="sm-task">
                        <router-link :to="{name:'task'}">
                            <i></i><span>{{txtLang[langName]['mTask']}}</span>
                        </router-link>
                    </li>
                    <li class="sm-mall">
                        <router-link :to="{name: 'Mall'}">
                            <i></i><span>{{txtLang[langName]['mMall']}}</span>
                        </router-link>
                    </li>
                    <li class="sm-guessList" v-if="isLoginShow">
                        <router-link :to="{name:'guessOrder'}">
                            <i></i><span>{{txtLang[langName]['mGuessList']}}</span>
                        </router-link>
                    </li>
                    <li class="sm-rule">
                        <router-link :to="{name:'guessRule'}">
                            <i></i><span>{{txtLang[langName]['mRule']}}</span>
                        </router-link>
                    </li>
                    <li class="sm-message" v-if="isLoginShow">
                        <router-link :to="{name: 'Message', params:{'noticeNum': data.notice_num}}">
                            <i></i><span :class="{'redPoint': this.data.notice_num > 0}">{{txtLang[langName]['mMessage']}}</span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </transition>
        <Loading v-show="isLoadingShow"></Loading>
    </div>
</template>

<script>
    import Loading from './common/Loading'
    import qs from 'qs';

    export default {
        name: "sideBar",
        components: {Loading},
        data() {
            return{
                isSideShow: false,
                isLoadingShow: false,
                isLoginShow: false,
                avatarUrl: '../../static/image/avatar_i.png',
                isHeight: false, // 控制图片的大小
                data:{}
            }
        },
        methods: {
            hideSide(){
                const that = this;

                if(that.isSideShow){
                    that.isSideShow = false;
                }else{
                    that.isSideShow = true;
                    that.isLoadingShow = true;
                    this.isUserLogin({
                        success: function(data){
                            that.isLoadingShow = false;
                            if(data == 1){
                                that.getUserInfo({
                                    lan: that.langIndex,
                                    success: that.setUserInfo
                                });
                            }
                        }
                    });
                }
            },

            /**
             * 登录跳转
             */
            toGo: function(){
                this.gotoLogin(this.isLoginShow);
            },

            /**
             * 设置用户信息
             * */
            setUserInfo: function(data){
                const that = this;

                var re = data.data;
                if(re.code == 200){
                    that.isLoginShow = true;
                    that.data = re.data;
                    if(that.data.avatar != '') {
                        that.avatarUrl = that.data.avatar;
                    }

                    localStorage.setItem('user_login_info', JSON.stringify(this.data));

                    this.$refs.imgShow.onload = () => {//判断头像图片宽高
                        if(this.$refs.imgShow.width == this.$refs.imgShow.height || this.$refs.imgShow.width < this.$refs.imgShow.height){
                            this.isHeight = true;
                        }else{
                            this.isHeight = false;
                        }
                    }
                }else{
                    that.isLoadingShow = false;
                }
            }

        },

        mounted(){//初始化
        },

        watch: {//监听值变化
            /*data: {
                handler(val){
                    this.data = val;
                },
                immediate: true,
                deep: true
            },
            token(val){
                this.token = val;
            },
            userInfo(val){
                this.userInfo = val;
            }*/
        }
    }
</script>

<style scoped>
    /* 侧边栏 */
    .side-mask{position:fixed;top:0;left:0;bottom:0;right:0;opacity:1;z-index:400;background:rgba(0,0,0,0.5);}
    .side-content{z-index:401;position:fixed;width:640px;height:100%;background:#171531;top:0;left:0;bottom:0;-webkit-overflow-scrolling:touch;}
    .fade-enter-to,.fade-leave-to{transition:opacity 0.3s}
    .fade-enter,.fade-leave-to{opacity:0}
    .slide-fade-enter-to,.slide-fade-leave-to{transition:transform 0.3s;transform:translate(0px,0px);}
    .slide-fade-enter,.slide-fade-leave-to{opacity:0;-webkit-transform:translate(-640px,0px);transform:translate(-640px,0px);-webkit-transition:opacity 0.3s ease-in-out 0.3s,-webkit-transform 0.3s ease-in-out;transition:opacity 0.3s ease-in-out 0.3s,transform 0.3s ease-in-out;}
    .side-close{display:inline-block;width:68px;height:68px;position:absolute;right:40px;top:40px;}
    .side-close:before, .side-close:after{content:'';display:inline-block;width:40px;height:4px;position:absolute;top:50%;left:10%;background:#65637f;}
    .side-close:before{transform:translate(20%,-20%) rotate(45deg);-webkit-transform:translate(20%,-20%) rotate(45deg);-moz-transform:translate(20%,-20%) rotate(45deg);-o-transform:translate(20%,-20%) rotate(45deg);}
    .side-close:after{transform:translate(20%,-30%) rotate(-45deg);-webkit-transform:translate(20%,-30%) rotate(-45deg);-moz-transform:translate(20%,-30%) rotate(-45deg);-o-transform:translate(20%,-30%) rotate(-45deg);}
    /* 头部信息 */
    .header-top{padding:95px 55px 0;text-align:center;}
    .avatar-box{display:inline-block;width:160px;height:160px;text-align:center;vertical-align:middle;border-radius:50%;border:10px solid #232048;background:#232048;overflow:hidden;position:relative;}
    .hovImg, .verImg{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);}
    .hovImg{width:100%;height:auto;}
    .verImg{width:auto;height:100%;}
    .user-info{display:inline-block;width:310px;margin-left:30px;text-align:left;vertical-align:middle;}
    .user-info h4{width:310px;color:#fff;font-size:48px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}
    .user-info p{color:#fd7446;font-size:30px;font-weight:bold;}
    .user-info p i{display:inline-block;width:40px;height:40px;margin-right:16px;vertical-align:top;background:url(../../static/image/icon_coin.png) no-repeat 0 0;background-size:100% auto;}
    .side-login{display:block;width:100%;height:75px;line-height:75px;margin-top:40px;color:#fff;font-size:30px;text-align:center;border-radius:16px;background:#232048;}
    /* 菜单 */
    .side-menu{max-height:55%;margin-top:40px;border-top:1px solid #232048;overflow-y:auto;}
    .side-menu li{display:block;padding:20px 55px;border-bottom:1px solid #232048;}
    .side-menu li a{display:block;position:relative;}
    .side-menu li a:after{content:'';display:inline-block;width:18px;height:18px;border-top:4px solid #65637f;border-right:4px solid #65637f;position:absolute;top:50%;right:15px;transform:translate(0,-50%) rotate(45deg);-webkit-transform:translate(0,-50%) rotate(45deg);-moz-transform:translate(0,-50%) rotate(45deg);-ms-transform:translate(0,-50%) rotate(45deg);-o-transform:translate(0,-50%) rotate(45deg);}
    .side-menu li a i{display:inline-block;width:80px;height:80px;vertical-align:middle;border-radius:50%;background:#232048 url(../../static/image/menu_icon.png) no-repeat center 0;background-size:100% auto;}
    .side-menu li a span{display:inline-block;margin-left:30px;color:#fff;font-size:30px;vertical-align:middle;}
    .side-menu li.sm-guess i{}
    .side-menu li.sm-task i{background-position:center -80px;}
    .side-menu li.sm-mall i{background-position:center -160px;}
    .side-menu li.sm-guessList i{background-position:center -240px;}
    .side-menu li.sm-rule i{background-position:center -320px;}
    .side-menu li.sm-message i{background-position:center -400px;}
    /* 红点 */
    .redPoint{position:relative}
    .redPoint:after{content:'';display:block;width:18px;height:18px;border-radius:50%;background:#fb5051;position:absolute;top:0;right:-24px;}
</style>


// WEBPACK FOOTER //
// src/components/sideBar.vue